require('./expensesByCategoryHistogramTooltip.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;
const { getLanguage } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

class ExpensesByCategoryHistogramTooltip extends React.Component {
    constructor(props) {
        super(props);

        this.buildTitleTotalExpenses = this.buildTitleTotalExpenses.bind(this);
        this.getTotalDetail = this.getTotalDetail.bind(this);
    }

    // Function to return translate text
    buildTitleTotalExpenses(type) {
        const title = type === 'TotalDebit' ? 'debitLegend' : 'creditLegend';
        return(title);
    }

    //Function to get the total amount
    getTotalDetail(payload) {
        let totalValue = 0;
        payload.map(payload => {
            if(payload.dataKey !== 'TotalLastYear') {
                totalValue += payload.value;
            }
        })

        return(totalValue);
    }

    render() {
        const { payload, currency, hasCreditCardCountry } = this.props;

        if (payload[0] && payload[1]) {
            const debitAmount = payload[0].payload.debitAmount;
            const creditAmount = payload[1].payload.creditAmount;
            const totalAmountCurrentYear = debitAmount + creditAmount;
            const currentYearDate = payload[0].payload.tooltipDateCurrent ? toCamelCase(payload[0].payload.tooltipDateCurrent) : toCamelCase(payload[0].payload.tooltipDate);
            return(
                <div className="expenses-category-histogram-tooltip">
                    <div className="expenses-category-histogram-tooltip__current-year">
                        <div className="expenses-category-histogram-tooltip__current-year__date">{toCamelCase(currentYearDate)}</div>
                        <div className="expenses-category-histogram-tooltip__current-year__debit">
                            <span>
                                <FormattedText value="historic-debitLegend"/>
                            </span>
                            <span>
                                <OneLineSymbolAmount
                                    language={getLanguage()}
                                    positiveAmount
                                    amountObject={{amount: debitAmount, currencySymbol: currency}}
                                    amountObjectFormatted={{currencySymbol: currency}}
                                />
                            </span>
                        </div>
                        {hasCreditCardCountry && <div className="expenses-category-histogram-tooltip__current-year__credit">
                            <span>
                                <FormattedText value="historic-creditLegend" />
                            </span>
                            <span>
                                <OneLineSymbolAmount
                                    language={getLanguage()}
                                    positiveAmount
                                    amountObject={{amount: creditAmount, currencySymbol: currency}}
                                    amountObjectFormatted={{currencySymbol: currency}}
                                />
                            </span>
                        </div>}
                    </div>
                    <div className="expenses-category-histogram-tooltip__total-amount">
                        <span>
                            <FormattedText value="historic-tooltipTotalLabel"/>
                        </span>
                        <span>
                            <OneLineSymbolAmount
                                language={getLanguage()}
                                positiveAmount
                                amountObject={{amount: totalAmountCurrentYear, currencySymbol: currency}}
                                amountObjectFormatted={{currencySymbol: currency}}
                            />
                        </span>
                    </div>
                    {payload[2] && <div className="expenses-category-histogram-tooltip__total-amount-compare-year">
                        <span>
                            <FormattedText value="historic-tooltipTotalLabel"/>
                            {' '}
                            { toCamelCase(payload[2].payload.tooltipDate) }
                        </span>
                        <span>
                            <OneLineSymbolAmount
                                language={getLanguage()}
                                positiveAmount
                                amountObject={{amount: payload[2].payload.debitAmountCompare + payload[2].payload.creditAmountCompare, currencySymbol: currency}}
                                amountObjectFormatted={{currencySymbol: currency}}
                            />
                        </span>
                    </div>}
                </div>
            )
        }
        return null;
    }
}

ExpensesByCategoryHistogramTooltip.propTypes = {
    payload: PropTypes.array,
    label: PropTypes.string,
    currency: PropTypes.string,
    type: PropTypes.string.isRequired,
    periodTime: PropTypes.string,
    hasDebit: PropTypes.bool,
    hasCredit: PropTypes.bool,
    hasCreditCardCountry: PropTypes.bool
};

module.exports = ExpensesByCategoryHistogramTooltip;
